import { render, staticRenderFns } from "./TransferTab63.vue?vue&type=template&id=214c90f8&scoped=true"
import script from "./TransferTab63.vue?vue&type=script&lang=js"
export * from "./TransferTab63.vue?vue&type=script&lang=js"
import style0 from "./TransferTab63.vue?vue&type=style&index=0&id=214c90f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c90f8",
  null
  
)

export default component.exports